import { useFormikContext } from 'formik'
import React from 'react'

import { translationsContext } from 'context/translations'
import { Calculate } from 'types/graphql/schema'
import { valuesType } from 'utils/values'

import { FieldSoB } from '../components/FieldSoB'
import { TableSection } from '../components/TableSection'
import { formatValue as f, formatUnits as fu } from '../utils'


export function SectionLongTermReturnsReproduction(props: {
  calculate: (values: valuesType) => void
  calculationResult: Calculate
  isPdf: boolean
}) {
  const t = React.useContext(translationsContext)
  const v = props.calculationResult
  const {values} = useFormikContext<valuesType>()
  return <TableSection
    colorGroupText="white"
    colorGroupBg="#C1CC00"
    colorTableBg="#F3F5CC"
    colorResultBg="#C1CC00"
    columns={[[
      '',
      t('values__units'),
      t('values__current'),
      t('values__adjusted'),
      t('values__difference'),
      {content: '', cellProps: {sx: {width: '250px'}}},
    ]]}
    data={[
      [
        {
          content: t('calc__repro__1_1'),
          tooltip: t('calc__repro__1_1__tt'),
        },
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__month')}`),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsReproductionCostCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__2_1'),
          tooltip:t('calc__repro__2_1__tt'),
        },
        fu(`${v.currency.sign}/${t('units__cow')}`),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsReplacementCostCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__3_1'),
          tooltip: t('calc__repro__3_1__tt'),
        },
        fu(`${v.currency.sign}/${t('units__'+v.weightUnits)} ${t('units__lw')}`),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsCullValueCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__4_1'),
          tooltip: t('calc__repro__4_1__tt'),
        },
        fu(`${v.currency.sign}/${t('units__calf')}`),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsCalfValueCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__5_1'),
          tooltip: t('calc__repro__5_1__tt'),
        },
        fu(t('units__month')),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsLastMonthToBreedCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__6_1'),
          tooltip: t('calc__repro__6_1__tt'),
        },
        fu(`${t('units__'+v.weightUnits)}/${t('units__cow')}/${t('units__day')}`),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsMinimumMilkToBreedCurrent" />},
        '',
        '',
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__7_1'),
          tooltip: t('calc__repro__7_1__tt'),
          borderBottom: true,
        },
        {...fu(`%/${t('units__year')}`), borderBottom: true},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsCullingRateCurrent" />, borderBottom: true},
        {content: '', borderBottom: true},
        {content: '', borderBottom: true},
        {content: '', cellProps: {sx: {backgroundColor: '#F3F5CC'}}},
      ],
      [
        {
          content: t('calc__repro__8_1'),
          tooltip: t('calc__repro__8_1__tt'),
        },
        fu('%'),
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsPregnancyRateCurrent" />},
        {...f(v.longTermReturnsReproduction.pregnancyRateWithProduct, 0)},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsPregnancyRateDifference" />},
        {
          content: <></>,
          cellProps: {sx: {backgroundColor: '#F3F5CC'}, rowSpan: 20},
        },
      ],
      [
        {
          content: t('calc__repro__9_1'),
          tooltip: t('calc__repro__9_1__tt'),
          borderBottom: true,
        },
        {...fu('%'), borderBottom: true},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsPregnancyLossCurrent" />, borderBottom: true},
        {...f(v.longTermReturnsReproduction.pregnancyLossWithProduct, 0), borderBottom: true},
        {content: <FieldSoB calculate={props.calculate}  isPdf={props.isPdf} name="longTermReturnsPregnancyLossDifference" />, borderBottom: true},
      ],
      [
        t('calc__repro__10_1'),
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`),
        f(v.longTermReturnsReproduction.calfSales.current, 0),
        f(v.longTermReturnsReproduction.calfSales.withProduct, 0),
        f(v.longTermReturnsReproduction.calfSales.difference, 0),
      ],
      [
        t('calc__repro__11_1'),
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`),
        f(v.longTermReturnsReproduction.mortalityCost.current, 0),
        f(v.longTermReturnsReproduction.mortalityCost.withProduct, 0),
        f(v.longTermReturnsReproduction.mortalityCost.difference, 0),
      ],
      [
        t('calc__repro__12_1'),
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`),
        f(v.longTermReturnsReproduction.reproductiveCost.current, 0),
        f(v.longTermReturnsReproduction.reproductiveCost.withProduct, 0),
        f(v.longTermReturnsReproduction.reproductiveCost.difference, 0),
      ],
      [
        t('calc__repro__13_1'),
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`),
        f(v.longTermReturnsReproduction.reproductiveCullingCost.current, 0),
        f(v.longTermReturnsReproduction.reproductiveCullingCost.withProduct, 0),
        f(v.longTermReturnsReproduction.reproductiveCullingCost.difference, 0),
      ],
      [
        t('calc__repro__14_1'),
        fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`),
        f(v.longTermReturnsReproduction.nonReproductiveCullingCost.current, 0),
        f(v.longTermReturnsReproduction.nonReproductiveCullingCost.withProduct, 0),
        f(v.longTermReturnsReproduction.nonReproductiveCullingCost.difference, 0),
      ],
      [
        {content: t('calc__repro__15_1'), borderTop: true},
        {...fu(`${v.currency.sign}/${t('units__cow')}/${t('units__year')}`), borderTop: true},
        {...f(v.longTermReturnsReproduction.totalReturns.current, 0), borderTop: true},
        {...f(v.longTermReturnsReproduction.totalReturns.withProduct, 0), borderTop: true},
        {...f(v.longTermReturnsReproduction.totalReturns.difference, 2), borderTop: true},
      ],
    ]}
    // dataRowsCollapsible={[]}
    dataRowsCollapsible={[0, 1, 2, 3, 4, 5, 6, 14]}
    groups={[
      {content: t('calc__repro__title'), firstRow: 0},
    ]}
    groupsColumn=''
    isPdf={props.isPdf}
    result={{
      padding: '32px',
      tooltip: t('calc__repro__result__tt'),
      title: t('calc__repro__result__title'),
      subtitle: t('calc__repro__result__subtitle'),
      units: `${v.currency.sign}/${t('units__' + values.resultsUnitsAmount)}/${t('units__' + values.resultsUnitsPeriod)}`,
      value: f(v.longTermReturnsReproduction.totalReturnsFinal.difference, 2).text,
    }}
  />
}